function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import get from 'lodash/get';
import PolygonIcon from 'svg/polygon.svg';
import PillsIcon from 'svg/pills.svg';
import messages from '../messages';
import * as shapes from '../shapes';
import styles from './PillTooltip.pcss';
var _React_PureComponent;
class PillTooltip extends (_React_PureComponent = React.PureComponent) {
    get unitLabel() {
        const unit = get(this.props, 'pill.unit');
        switch(unit){
            case 1:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pill.labels.units.injections));
            case 2:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pill.labels.units.pills));
            case 3:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pill.labels.units.milligrams));
            case 4:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pill.labels.units.units));
            default:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pill.labels.units.none));
        }
    }
    renderTitle() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.pillTooltip__title,
            children: [
                /*#__PURE__*/ _jsx(PillsIcon, {
                    className: styles.pillTooltip__titleIcon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.pillTooltip__titleText,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pill.label))
                })
            ]
        });
    }
    renderPill() {
        const { pill } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.pillTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.pillTooltip__detailType,
                    children: pill.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.pillTooltip__detailValue,
                    children: [
                        pill.value,
                        " ",
                        this.unitLabel
                    ]
                })
            ]
        });
    }
    renderTime() {
        const { pill } = this.props;
        const time = moment.unix(pill.timestamp).utc().format('LT');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.pillTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.pillTooltip__detailType,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.time))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.pillTooltip__detailValue,
                    children: time
                })
            ]
        });
    }
    renderDetails() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.pillTooltip__details,
            children: [
                this.renderPill(),
                this.renderTime()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.pillTooltip,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.pillTooltip__content,
                children: [
                    this.renderTitle(),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.pillTooltip__separator
                    }),
                    this.renderDetails(),
                    /*#__PURE__*/ _jsx(PolygonIcon, {
                        width: "17",
                        height: "12",
                        className: styles.pillTooltip__polygon
                    })
                ]
            })
        });
    }
}
_define_property(PillTooltip, "propTypes", {
    // Explicit props
    pill: shapes.pill.isRequired
});
export default withStyles(styles)(PillTooltip);
